import conditions from "../../assets/files/ru/usloviya-obrabotki-pol'zovatel'skih-dannyh-na-sajtah-AO-Bank-131.pdf";
import policy from "../../assets/files/ru/personal_data_processing_policy.pdf";
import { BANK_ADDRESS, BANK_PHONE } from "../../constants";
import { formatPhoneNumber } from "../../utils/formatPhoneNumber";

export default {
  businessSolutions: "Решения для бизнеса",
  forIndividuals: "Частным лицам",
  debitCards: "Дебетовые карты",
  deposits: "Вклады",
  contactsPage: "«Обратная связь»",
  feedback: "Обратная связь",
  payouts: "Выплаты",
  onlinePayments: "Прием платежей",
  developers: "Разработчикам",
  pricing: "Тарифы",
  company: "О нас",
  financialSecurity: "Финансовая безопасность",
  aboutBank: "О банке 131",
  offices: "Офисы",
  vacancy: "Вакансии",
  termsOfUserDataProcessing: "Условия обработки пользовательских данных на\u00A0сайте",
  termsOfUserDataProcessingLink: conditions,
  personalDataProcessingPolicy: "Политика в отношении обработки персональных данных",
  personalDataProcessingPolicyLink: policy,
  blog: "Блог",
  legalInformation: "Раскрытие информации",
  email: "Электронная почта",
  workSchedule: "работает ежедневно, с 9:00 по 20:00 по московскому времени",
  onTheWebsite: "на сайте",
  additionalWayToSubmitRequestsTitle: "Дополнительные способы приема обращений:",
  additionalWayToSubmitRequests: "Форма обратной связи на сайте в разделе",
  remoteBankingSystem: "Система дистанционного банковского обслуживания «Интернет-Клиент» (для юридических лиц на основании заключенного договора)",
  address: "Адрес",
  officeAddress: BANK_ADDRESS,
  phoneNumber: formatPhoneNumber(BANK_PHONE),
  phoneNumberDescription: "звонок по России бесплатный",
  addressesForReceivingRequests: "Адреса для приема обращений",
  contactUs: "КОНТАКТЫ",
  contactsForDirectingApplicationsToTheBank: "Контакты для направления обращений в банк",
  workingWithInternetBanking: "Работа с интернет-банком",
  weAreInSocial: "МЫ В СОЦИАЛЬНЫХ СЕТЯХ",
  ideasAndPartnerships: "Предложения и идеи",
  media: "Пресса",
  instructions: "Инструкции",
  insuranceInfo: "АО «Банк 131» является участником системы страхования вкладов",
  insuranceInfoLinkText: "Информация о процентных ставках по договорам банковского вклада с физическими лицами",
  copyright: "© 2019-{{currentYear}}, АО «Банк 131», официальный сайт. Базовая лицензия на осуществление банковских операций со средствами в рублях и иностранной валюте (с правом привлечения во вклады денежных средств физических лиц) и на осуществление банковских операций с драгоценными металлами №3538 от 29 ноября 2024 г.",
  splitPayment: "Мультирасчеты",
  moneyTransfer: "Переводы",
  moneyTransferFromRussia: "Денежные переводы <nobr>из России</nobr>",
  rulesDocumentsDengiRu: "Правила и документы Платежной системы dengi.ru",
  faq: "FAQ",
  forSelfEmployed: "Для самозанятых",
  onlineBank: "Интернет-банк для бизнеса",
  bankAccount: "Расчетный счет",
  escrowAccount: "Номинальный счет",
  paymentBot: "Прием платежей в Telegram",
  mainMenuItems: [
    [
      {
        title: "Выплаты",
        url: "/products/payouts",
        icon: "Wallet.svg"
      },
      {
        title: "Прием платежей",
        url: "/products/payments",
        icon: "Card.svg"
      },
      {
        title: "Для самозанятых",
        url: "/self-employed",
        icon: "Smile.svg"
      }
    ],
    [
      {
        title: "Номинальный счет",
        url: "/products/escrow-account",
        icon: "EscrowAccount.svg"
      },
      {
        title: "Интернет-банк для бизнеса",
        url: "/products/online-banking",
        icon: "onlineBanking.svg"
      }
    ],
    [
      {
        title: "Расчетный счет",
        url: "/products/account",
        icon: "Account.svg"
      },
      {
        title: "Система быстрых платежей",
        url: "/products/sbp",
        icon: "SBP.svg"
      }
    ]
  ]
}
